import { clearFilterMenuPortalDismissGuard } from 'components/cui_filter_menu/filter_menu_portal_dismiss_guard'

const FILTER_FIELD_MENU_SELECTOR = '[data-component="filter-dropdown-menu"]'
const SCOPE_OVERLAY_SELECTOR = '[data-meetings-filter-scope-overlay="true"]'
const FILTER_FIELD_TRIGGER_SELECTOR = [
  '[data-testid="filter-dropdown-trigger"]',
  '[data-testid="filter-date-range-trigger"]',
  '[data-testid="packages-filter-trigger"]',
  '[data-testid="scope-dropdown-control"]',
].join(', ')

const hasOpenFilterFieldDropdown = ({ getPortalRoots, getMenuContentElement }) => {
  if (getPortalRoots().some((portal) => portal?.querySelector(FILTER_FIELD_MENU_SELECTOR))) {
    return true
  }

  const menuContent = getMenuContentElement()
  return Boolean(menuContent?.querySelector(FILTER_FIELD_MENU_SELECTOR))
}

const stopEscapeEvent = (event) => {
  event.preventDefault()
  event.stopPropagation()
  event.stopImmediatePropagation()
}

const getExpandedFilterFieldTrigger = (menuContent) => {
  if (!menuContent) return null

  const triggers = menuContent.querySelectorAll(FILTER_FIELD_TRIGGER_SELECTOR)
  return Array.from(triggers).find(
    (trigger) => trigger.getAttribute('aria-expanded') === 'true',
  ) ?? null
}

const closeOpenFilterFieldDropdowns = ({ getPortalRoots, getMenuContentElement }) => {
  const menuContent = getMenuContentElement()
  if (!menuContent) return false

  const expandedTrigger = getExpandedFilterFieldTrigger(menuContent)

  if (expandedTrigger instanceof HTMLElement) {
    expandedTrigger.click()
    return true
  }

  if (!hasOpenFilterFieldDropdown({ getPortalRoots, getMenuContentElement })) {
    return false
  }

  const triggers = menuContent.querySelectorAll(FILTER_FIELD_TRIGGER_SELECTOR)
  if (triggers.length === 1 && triggers[0] instanceof HTMLElement) {
    triggers[0].click()
    return true
  }

  return false
}

export const createShouldDeferFilterMenuEscapeClose = ({
  getPortalRoots,
  getMenuContentElement,
}) => () => {
  if (hasOpenFilterFieldDropdown({ getPortalRoots, getMenuContentElement })) return true

  const active = document.activeElement
  if (!(active instanceof Element)) return false

  if (active.closest(FILTER_FIELD_MENU_SELECTOR)) return true
  if (active.closest(SCOPE_OVERLAY_SELECTOR)) return true
  if (active.closest('[data-component="scope-dropdown-menu"], [data-testid="scope-dropdown-options"]')) {
    return true
  }
  if (active.closest('[role="listbox"], [role="combobox"]')) return true

  return false
}

export const handleFilterMenuEscapeKeydown = (event, {
  onClosePanel,
  getContainerElement,
  getPortalRoots,
  getMenuContentElement,
}) => {
  if (event.key !== 'Escape' || event.isComposing) return false

  const shouldDefer = createShouldDeferFilterMenuEscapeClose({
    getPortalRoots,
    getMenuContentElement,
  })

  const menuContent = getMenuContentElement()
  const shouldCloseFieldDropdown = shouldDefer()
    || getExpandedFilterFieldTrigger(menuContent) != null

  if (shouldCloseFieldDropdown) {
    if (closeOpenFilterFieldDropdowns({ getPortalRoots, getMenuContentElement })) {
      stopEscapeEvent(event)
      clearFilterMenuPortalDismissGuard()
      return true
    }

    if (shouldDefer()) {
      // Defer panel close for nested controls. CUI FilterMenu also listens on document
      // capture; SchedulingFilterMenu suppresses its close callbacks while deferring.
      return false
    }
  }

  stopEscapeEvent(event)
  onClosePanel()
  getContainerElement()
    ?.querySelector('button[aria-haspopup="dialog"]')
    ?.focus()

  return true
}
